import { render, staticRenderFns } from "./masrafmerkezi.vue?vue&type=template&id=1af3f432&scoped=true"
import script from "./masrafmerkezi.vue?vue&type=script&lang=js"
export * from "./masrafmerkezi.vue?vue&type=script&lang=js"
import style0 from "./masrafmerkezi.vue?vue&type=style&index=0&id=1af3f432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af3f432",
  null
  
)

export default component.exports